import Event from '@model/Event'
import NoticeboardEntry from '@model/NoticeboardEntry'
import { Model } from 'pinia-orm'
import { BelongsTo, Num, Str } from 'pinia-orm/decorators'

export default class NoticeboardFile extends Model {
    static entity = 'noticeboard-files'

    @Num(0, { notNullable: true })
    declare id: number
    @Num(0)
    declare noticeboardEntryId: string
    @BelongsTo(() => NoticeboardEntry, 'noticeboardEntryId')
    declare noticeboardEntry: Event
    @Str(null)
    declare name: string
    @Num(0)
    declare size: number
    @Str(null)
    declare title: string
    @Str(null)
    declare desc: string

    static piniaOptions = {
        persist: true,
    }
}
